import * as actions from "../actions/playerActions";

const initialState = {
  channel: null,
  title: ""
};

export default function player(state = initialState, action) {
  switch (action.type) {
    case actions.SET_CHANNEL: {
      return {
        ...state,
        channel: action.channel,
        title: action.title || "",
      };
    }
    case actions.CLOSE: {
      return initialState;
    }
    default: {
      return state;
    }
  }
}


// WEBPACK FOOTER //
// ./app/reducers/player.js